import {Suspense} from 'react';
import {lazyWithRetry} from 'src/utils/lazyWithRetry';
import {Outlet} from 'react-router-dom';
// auth
import {AuthGuard} from 'src/auth/guard';
// components
import {LoadingScreen} from 'src/components/loading-screen'

const ReportDetailsPage = lazyWithRetry(() => import('src/pages/reportDetails/ReportDetailsPage'));

export const reportDetailsRoutes = [
  {
    path: '/report-details',
    element: (
      <AuthGuard>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </AuthGuard>
    ),
    children: [
      {
        path: ':id',
        element: <ReportDetailsPage />,
      },
    ],
  },
];
